import React from 'react';
import { COLORS } from '../../../theme';

export default function ObservacoesTab({ form, onChange }) {
  return (
    <textarea
      value={form.observacoes || ''}
      onChange={e => onChange('observacoes', e.target.value)}
      placeholder="Observações gerais sobre este cadastro..."
      style={{
        width: '100%', minHeight: 240, border: `1.5px solid ${COLORS.border}`, borderRadius: 8,
        padding: 12, fontSize: 14, fontFamily: 'inherit', color: COLORS.text, background: COLORS.bg, resize: 'vertical'
      }}
    />
  );
}
